<template>
  <TitleFrame text="実験参加">
    <template slot="contents">
      <ExperimentParticipationCheck v-if="qid===0"  :is-test=isTest @click-ok="onClickOkParticipant" />
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import ExperimentAgreeCheck from '@/components/Organisms/ExperimentAgreeCheck'
import ExperimentParticipationCheck from '@/components/Organisms/ExperimentParticipationCheck'
import Firebase from './../../firebase'

export default {
  name: 'experiment-agree',
  components: {
    TitleFrame,
    ExperimentAgreeCheck,
    ExperimentParticipationCheck
  },
  computed: {
    ...mapState([
      'isTest',
      'isAgreed',
      'isAnswered',
      'isExperimentParticipant',
      'uid'
    ]),
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  data () {
    return {
      qid: 0
    }
  },
  methods: {
    ...mapMutations(['loadingStart', 'loadingEnd']),
    onClickOkParticipant (agreeStatus) {
      if (!agreeStatus) {
        this.$router.push({name: 'RouteSearch'})
      } else {
        Firebase.agreeExperimentParticipant()
        this.$router.push({name: 'RouteSearch'})
      }
    }
  },
  watch: {
    isExperimentParticipant: {
      immideate: true,
      handler: function () {
        if (this.isExperimentParticipant) {
          // 回答済みならばルート検索画面へ
          this.$router.push({name: 'RouteSearch'})
        } else {
          // 未回答ならば回答画面を表示
          this.loadingEnd()
        }
      }
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    }
    if (this.isExperimentParticipant) {
      // 回答済みならばルート検索画面へ
      this.$router.push({name: 'RouteSearch'})
    } else {
      //  未回答ならば回答画面を表示
      this.loadingEnd()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Pages/ExperimentAgree.vue